<div
  class="flex flex-wrap align-items-center justify-content-center"
  [ngClass]="{ 'h-screen': fullScreen }"
>
  <div
    class="flex align-items-center align-items-center justify-content-center"
  >
    <div class="text-center">
      <img
        *ngIf="showLogo"
        [alt]="selectedOrganization?.name || 'Boma'"
        [src]="
          selectedOrganization?.images &&
          selectedOrganization?.images.length > 0
            ? selectedOrganization.images[0].sizes?.length > 1
              ? (selectedOrganization.images
                | getFirstAvailableImageForSize: '200')
              : (selectedOrganization?.images)[0].url
            : '/assets/layout/images/brand/logo-h-dark-text.svg'
        "
        class="logo-image"
        id="app-logo"
      />
      <ng-container *ngIf="!loaded">
        <h5>{{ loadingText }}</h5>
        <p *ngIf="showTip && tip">
          Tip: {{ tip.shortcut }} {{ tip.description }}
        </p>
        <p class="text-center mt-5">
          <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
        </p>
      </ng-container>
    </div>
  </div>
</div>
